export class BaseConnectorStrategy {
    getSigners() {
        return this.signers;
    }
    onSessionDisconnect(callback) {
        var _a;
        (_a = this.walletConnectService.getClient()) === null || _a === void 0 ? void 0 : _a.on("session_delete", callback);
    }
    onSessionExpire(callback) {
        var _a;
        (_a = this.walletConnectService.getClient()) === null || _a === void 0 ? void 0 : _a.on("session_expire", callback);
    }
}
